import React from 'react';
import { useTheme } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import {
  Container, Title, LinesContainer, Line,
} from './ProgressBarStep.styles';

import { ONBOARDING_STEPS } from '@/utils/constants';

type ProgressBarStepProps = {
  currentStep: number;
  style?: React.CSSProperties;
};

const ProgressBarStep: React.FC<ProgressBarStepProps> = ({ currentStep, style }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const stepIndex = Math.max(0, Math.min(currentStep - 1, ONBOARDING_STEPS.length - 1));
  const step = ONBOARDING_STEPS[stepIndex];
  const activeColor = theme.palette.secondary.main;
  const inactiveColor = theme.palette.grey[200];
  return (
    <Container style={style}>
      <Title style={{ color: activeColor }}>
        {`${t('onboarding.steps.step_label', { step: currentStep })}: ${t(step.titleKey)}`}
      </Title>
      <LinesContainer>
        {ONBOARDING_STEPS.map((stepItem, index) => (
          <Line
            key={stepItem.titleKey}
            style={{ backgroundColor: currentStep >= index + 1 ? activeColor : inactiveColor }}
          />
        ))}
      </LinesContainer>
    </Container>
  );
};

export default ProgressBarStep;
